import _extends from "@babel/runtime/helpers/extends";
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import React from 'react';
import { AnswerTemplate } from "../CustomerComponents/AnswerTemplate";
import { NoPartnerResponseText } from "../CustomerComponents/NoPartnerResponseText";
import { QuestionTemplate } from "../CustomerComponents/QuestionTemplate";
import { RichComponent } from "../CustomerComponents/RichComponent";
/**
 * Priority
 * -> Response not provided - no icon
 * -> iconBefore defined for the QnA
 * -> Answer text contains "No" - Appropriate icon
 * -> Anything else default icon
 */
const getIconBefore = (answerAsConfig, iconBefore) => {
  var _answerAsConfig$;
  if (!answerAsConfig) {
    return null;
  }
  if (iconBefore) {
    return iconBefore;
  }

  // Typecasted as we only care about showing the appropriate icon
  // for "No". Check 'yesNoNull' function to understand how the
  // ui config for that looks like
  const text = (_answerAsConfig$ = answerAsConfig[0]) === null || _answerAsConfig$ === void 0 ? void 0 : _answerAsConfig$.text;
  const answerText = text === null || text === void 0 ? void 0 : text.toLowerCase();
  if (answerText !== null && answerText !== void 0 && answerText.includes('no')) {
    return /*#__PURE__*/React.createElement(EditorCloseIcon, {
      label: ""
    });
  }
  return /*#__PURE__*/React.createElement(EditorDoneIcon, {
    label: ""
  });
};
export const getQnA = (qna, transformedAppTrustData) => qna.map(_ref => {
  let {
    question,
    answer,
    iconBefore
  } = _ref;
  const Question = /*#__PURE__*/React.createElement(QuestionTemplate, null, question.map((config, index) => /*#__PURE__*/React.createElement(RichComponent, _extends({
    key: index
  }, config))));
  const answerAsConfig = answer(transformedAppTrustData);
  const Answer = /*#__PURE__*/React.createElement(AnswerTemplate, {
    iconBefore: getIconBefore(answerAsConfig, iconBefore)
  }, answerAsConfig ? answerAsConfig.map((config, index) => /*#__PURE__*/React.createElement(RichComponent, _extends({
    key: index
  }, config))) : /*#__PURE__*/React.createElement(NoPartnerResponseText, null));
  return {
    question: Question,
    answer: Answer
  };
});
export default getQnA;